import Grid from '@mui/material/Grid'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import React, { useState, useEffect } from 'react'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Alert from '../../features/error/Alert'
import JNJFooter from '../../features/jnj-footer/JNJFooter'
import { Button } from '../../features/section-components/Button'
import { SectionHeader } from '../../features/section-components/SectionHeader'
import styles from './EditPhoneNumber.module.scss'
import { ReactComponent as CustomDeleteIcon } from '../../assets/custom_delete_icon.svg'
import { LoadingIcon } from '../../features/section-components/LoadingIcon'
import { TextboxDesktop } from '../../features/section-components/Textbox'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import PhoneCodeDropdown from '../../features/section-components/PhoneCodesDropdown/PhoneCodeDropdown'
import { CheckPhoneNumber } from '../../util/phoneUtils'

function EditPhoneDesktop({
  userCallStatus,
  phoneNumber,
  handleSubmit,
  handleChange,
  currentCountry,
  currentCountryPhoneCode,
  handleCountryCode,
  removeSessionStorage,
  isAPhoneNumber,
  handleDelete,
  isDeleting,
  isTouched,
  setIsTouched,
  supportText,
  setSupportText,
  triedValidate,
  hasError,
  errorMessage,
  settriedValidate,
  isSaving,
  t,
  setIsAPhoneNumber,
  formattedPhone,
  phoneField,
  phoneCallStatus,
}) {
  const [isLoading, setIsLoading] = useState(false)

  const handleDeleteClick = async () => {
    await handleDelete()
  }

  function confirmPhoneField() {
    if (
      phoneField
      && currentCountry
      && typeof setIsAPhoneNumber === 'function'
    ) {
      setIsAPhoneNumber(CheckPhoneNumber(phoneField, currentCountry))
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
      confirmPhoneField()
    }, 700)

    return () => clearTimeout(timer)
  }, [phoneNumber, currentCountry, setIsAPhoneNumber])

  if (isLoading) {
    return (
      <MarginWrapper>
        <LoadingIcon isLoading />
      </MarginWrapper>
    )
  }

  const isCallsLoading = isLoading
    || userCallStatus === 'loading'
    || userCallStatus === 'idle'
    || phoneCallStatus === 'loading'
    || phoneCallStatus === 'idle'

  return (
    <MarginWrapper>
      <LoadingIcon isLoading={isCallsLoading}>
        <div className={styles['edit-phone-post-header']} />
        <div className={styles['edit-phone-container']}>
          <div className={styles['home-section']}>
            <Link
              to="/account"
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
              color="black"
            >
              <ArrowBackIosIcon
                className={styles['home-icon']}
                fontSize="inherit"
              />
              <div className={styles['home-text']}>{t('account-tab')}</div>
            </Link>
          </div>

          <SectionHeader text={t('label-phone-num')} size="medium" />
          <span className={styles['form-secondary-text']}>
            {t('support-text-phone-auth')}
          </span>

          {hasError && (
            <div className={styles['alert-container']}>
              <Alert
                message={t(errorMessage)}
                onClose={() => { }}
                alertStyle="error-alert"
                headerText="Error"
              />
            </div>
          )}

          {phoneNumber ? (
            <div className={styles['primary-number-container']}>
              <div className={styles['primary-number-section']}>
                <div className={styles['primary-number-label']}>
                  <span className={styles['form-label']}>
                    {t('label-primary-phone-num')}
                  </span>
                  <span className={styles['phone-number']}>
                    {formattedPhone}
                  </span>
                </div>
                <Button
                  type="button"
                  buttonStyle="cta-yellow-oval-delete"
                  icon={
                    isDeleting ? (
                      <LoadingIcon isLoading size="small" color="black" />
                    ) : (
                      <CustomDeleteIcon />
                    )
                  }
                  text={t('button-delete')}
                  onClick={handleDeleteClick}
                  disabled={isDeleting}
                />
              </div>
              <div className={styles['edit-phone-div-border']} />
            </div>
          ) : (
            <>
              <div className={styles['form-field']}>
                <span className={styles['form-label']}>
                  {t('label-edit-phone-country-dropdown')}
                </span>
                <PhoneCodeDropdown
                  dropdownLabel="Select"
                  value={currentCountry}
                  handleClick={handleCountryCode}
                  // eslint-disable-next-line arrow-parens
                  onChange={(e) => {
                    handleChange(e.target.value)
                    // eslint-disable-next-line no-unused-expressions
                    currentCountry
                      ? setSupportText('')
                      : setSupportText('Field is Required')
                  }}
                  error={triedValidate && !currentCountry}
                  supportText={supportText}
                />
              </div>
              <div className={styles['form-field']}>
                <span className={styles['form-label']}>
                  {t('label-edit-phone-number-input')}
                </span>
                <div>
                  <TextboxDesktop
                    className={styles['form-phone-code-input']}
                    disabled
                    disabledBackground="#F0F0F0"
                    value={currentCountryPhoneCode}
                    maxWidth={
                      currentCountryPhoneCode?.length > 3
                        ? `${currentCountryPhoneCode?.length}rem !important`
                        : '62px !important'
                    }
                    minWidth="0 !important"
                    borderRadius="4px 0 0 4px"
                    textAlign="center !important"
                  />

                  <TextboxDesktop
                    value={phoneField}
                    // eslint-disable-next-line arrow-parens
                    onChange={(e) => {
                      handleChange(e.target.value)
                      // eslint-disable-next-line no-unused-expressions
                      if (e.target.value.trim() !== '') {
                        setSupportText('')
                      }
                    }}
                    error={isTouched && !isAPhoneNumber}
                    supportText={supportText}
                    borderRadius="0 4px 4px 0"
                    isNumeric
                    required
                  />
                </div>
              </div>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={10}
                xl={10}
                className={styles['edit-phone-buttons']}
              >
                <Button
                  text={isSaving ? '' : t('button-save-changes')}
                  onClick={() => {
                    confirmPhoneField()
                    if (isAPhoneNumber) {
                      handleSubmit()
                    } else {
                      setSupportText('Field is Required')
                      setIsTouched(true)
                      settriedValidate(true)
                    }
                  }}
                  buttonStyle="cta-red-oval"
                  disabled={isSaving}
                  icon={
                    isSaving ? (
                      <LoadingIcon isLoading size="small" color="white" />
                    ) : null
                  }
                />

                <Link to="/account" style={{ textDecoration: 'none' }}>
                  <Button
                    text={t('button-cancel')}
                    buttonStyle="filled-grey-oval"
                    onClick={() => removeSessionStorage(true)}
                  />
                </Link>
              </Grid>
            </>
          )}
        </div>

        <div className={styles['JNJ-footer']}>
          <JNJFooter />
        </div>
      </LoadingIcon>
    </MarginWrapper>
  )
}

EditPhoneDesktop.propTypes = {
  t: PropTypes.func.isRequired,
  userCallStatus: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  currentCountry: PropTypes.string.isRequired,
  currentCountryPhoneCode: PropTypes.string.isRequired,
  handleCountryCode: PropTypes.func.isRequired,
  removeSessionStorage: PropTypes.func.isRequired,
  isAPhoneNumber: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  isTouched: PropTypes.bool.isRequired,
  setIsTouched: PropTypes.func.isRequired,
  supportText: PropTypes.string.isRequired,
  setSupportText: PropTypes.func.isRequired,
  triedValidate: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  settriedValidate: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  setIsAPhoneNumber: PropTypes.func.isRequired,
  formattedPhone: PropTypes.string.isRequired,
  phoneField: PropTypes.string.isRequired,
  phoneCallStatus: PropTypes.string.isRequired,
}

export default EditPhoneDesktop
